<div class="popupForm" style="min-height: unset;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span>Pick users to share course</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke"
                        style="     margin: 20px 0px 00px 0px !important; padding: 0px !important;">
      <div cdkDropListGroup class="flex-row">
        <div class="flex-container">
          <h2>Pick from these ({{pickFrom.length}} items)</h2>
          <div
            cdkDropList
            [cdkDropListData]="pickFrom"
            class="drag-list-container"
            (cdkDropListDropped)="dropItem($event)">
            <div class="drag-item" *ngFor="let item of pickFrom; let j = index;" cdkDrag>
              <div class="">
                <img alt=""
                     src="{{pickFrom[j]['picture_ava']}}" class="list-item-image"
                     style="{{ pickFrom[j].itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                />
              </div>
              <div class="drag-item-label">
                {{j+1}}. {{pickFrom[j]['name']}}
              </div>
            </div>
          </div>
        </div>
        <div class="flex-container">
          <h2>Share to these ({{pickTo.length}} items)</h2>
          <div
            cdkDropList
            [cdkDropListData]="pickTo"
            class="drag-list-container"
            (cdkDropListDropped)="dropItem($event)">
            <div class="drag-item" *ngFor="let item of pickTo; let j = index;" cdkDrag>
              <div class="">
                <img alt=""
                     src="{{pickTo[j]['picture_ava']}}" class="list-item-image"
                     style="{{ pickTo[j].itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                />
              </div>
              <div class="drag-item-label">
                {{j+1}}. {{pickTo[j]['name']}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <!--<button type="button" mat-button class="cancel widerButton font16">-->
    <!--Cancel-->
    <!--</button>-->
    <!--<button type="submit" class="widerButton font16" mat-raised-button color="accent">-->
    <!--OK-->
    <!--</button>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</div>
